export default [

  //出库单
  {
    path: "/outbill",
    name: "outbill",
    component: () => import('../components/iobill/outbill.vue'),
    meta: { keepAlive: false }
  },
  {
    path: "/outbill/add",
    name: "addoutbill",
    component: () => import('../components/iobill/edit-outbill.vue'),
    meta: { keepAlive: true }
  },
  {
    path: "/outbill/edit",
    name: "editoutbill",
    component: () => import('../components/iobill/edit-outbill.vue'),
    meta: { keepAlive: true }
  },
  {
    path: "/outbill/view",
    name: "viewoutbill",
    component: () => import('../components/iobill/view-outbill.vue'),
    meta: { keepAlive: true }
  },

  {
    path: "/outbill/print-a4",
    name: "printoutbill-a4",
    component: () => import('../components/printf-reports/outbill-reports/a4.vue'),
    meta: { keepAlive: true }
  },

  //入库单

  {
    path: "/inbill",
    name: "inbill",
    component: () => import('../components/iobill/inbill.vue'),
    meta: { keepAlive: false }
  },
  {
    path: "/inbill/add",
    name: "addinbill",
    component: () => import('../components/iobill/edit-inbill.vue'),
    meta: { keepAlive: true }
  },
  {
    path: "/inbill/edit",
    name: "editinbill",
    component: () => import('../components/iobill/edit-inbill.vue'),
    meta: { keepAlive: true }
  },
  {
    path: "/inbill/view",
    name: "viewinbill",
    component: () => import('../components/iobill/view-inbill.vue'),
    meta: { keepAlive: true }
  },
  {
    path: "/inbill/print-a4",
    name: "printinbill-a4",
    component: () => import('../components/printf-reports/inbill-reports/a4.vue'),
    meta: { keepAlive: true }
  },

  //盘点单
  {
    path: "/pdbill",
    name: "pdbill",
    component: () => import('../components/pdbill/pdbill.vue'),
    meta: { keepAlive: false }
  },
  {
    path: "/pdbill/add",
    name: "addpdbill",
    component: () => import('../components/pdbill/edit-pdbill.vue'),
    meta: { keepAlive: true }
  },
  {
    path: "/pdbill/edit",
    name: "editpdbill",
    component: () => import('../components/pdbill/edit-pdbill.vue'),
    meta: { keepAlive: true }
  },
  {
    path: "/pdbill/view",
    name: "viewpdbill",
    component: () => import('../components/pdbill/view-pdbill.vue'),
    meta: { keepAlive: true }
  },
  {
    path: "/pdbill/print-a4",
    name: "printpdbill-a4",
    component: () => import('../components/printf-reports/pdbill-reports/a4.vue'),
    meta: { keepAlive: true }
  },

  //调货单
  {
    path: "/dbbill",
    name: "dbbill",
    component: () => import('../components/dbbill/dbbill.vue'),
    meta: { keepAlive: false }
  },
  {
    path: "/dbbill/add",
    name: "adddbbill",
    component: () => import('../components/dbbill/edit-dbbill.vue'),
    meta: { keepAlive: true }
  },
  {
    path: "/dbbill/edit",
    name: "editdbbill",
    component: () => import('../components/dbbill/edit-dbbill.vue'),
    meta: { keepAlive: true }
  },
  {
    path: "/dbbill/view",
    name: "viewdbbill",
    component: () => import('../components/dbbill/view-dbbill.vue'),
    meta: { keepAlive: true }
  },
  {
    path: "/dbbill/print-a4",
    name: "printdbbill-a4",
    component: () => import('../components/printf-reports/dbbill-reports/a4.vue'),
    meta: { keepAlive: true }
  },
]



// WEBPACK FOOTER //
// ./src/router/bill-router.js